import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=78ec14dc&scoped=true"
var script = {}
import style0 from "./Guidance.vue?vue&type=style&index=0&id=78ec14dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec14dc",
  null
  
)

export default component.exports